export default __webpack_public_path__ + "static/media/Copy-dark.e08762b5.svg";